<template>
	<AppLayout
		:title="role.title ?? trans('general.users.roles.edit.title')"
		:subtitle="transChoice('admin.roles.abilities', role.abilities_count)"
		:return-url="route('association.roles.index')"
		:return-label="trans('general.users.roles.title')"
	>
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="save">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('general.confirm') }}
			</PrimaryButton>
		</template>
		<Empty v-if="permissions.length === 0"/>
		<CardGrid v-else>
			<Card v-for="(abilities, title) in permissions" :key="`permission-${title}`" :title="title.toString()">
				<Switch v-for="ability in abilities" :key="`${ability.ability}.${ability.model}`" v-model="ability.active" :label="ability.label"/>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Role} from '@/Types/Association/Role'
import {trans, transChoice} from 'laravel-vue-i18n'
import Switch from '@/Components/UI/Switches/Switch.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {type PermissionRepresentation} from '@/Types/System/PermissionRepresentation'

const props = defineProps<{
	role:Role,
	permissions:Array<PermissionRepresentation>,
}>()

const role:Ref<Role> = ref(props.role)
const working:Ref<boolean> = ref(false)
const permissions:Ref<Array<PermissionRepresentation>> = ref(props.permissions)

function save():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.roles.update', role.value.id), {
			permissions: permissions.value,
		}).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>